import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';
import { GridPropTypes, NumColumns } from '../constants';
import { mapBreakpoints } from '../mixins/breakpoint';
import column, {
    columnEnd,
    columnInline,
    columnOffset,
    columnSize,
} from '../mixins/column';

const end = (colEnd) => {
    if (typeof colEnd === 'boolean') {
        return colEnd ? columnEnd : undefined;
    }

    if (typeof colEnd === 'object') {
        return mapBreakpoints(colEnd, (isEnd) => {
            return isEnd ? columnEnd : columnInline;
        });
    }
};

const size = (colSize) => {
    if (typeof colSize === 'number') {
        return columnSize(colSize);
    }

    if (typeof colSize === 'object') {
        return mapBreakpoints(colSize, columnSize);
    }
};

const offset = (colOffset) => {
    if (typeof colOffset === 'number') {
        return columnOffset(colOffset);
    }

    if (typeof colOffset === 'object') {
        return mapBreakpoints(colOffset, columnOffset);
    }
};

class BaseColumn extends React.PureComponent {
    render() {
        // eslint-disable-next-line no-unused-vars
        const {
            component: Component = 'div',
            children,
            size: numColumns,
            ...props
        } = this.props;

        return (
            <Component {...filterToValidAttributes(props)}>
                {children}
            </Component>
        );
    }
}

const Column = styled(BaseColumn)`
    ${column}
    ${(props) => size(props.size)}
    ${(props) => offset(props.offset)}
    ${(props) => end(props.end)}
`;

Column.propTypes = {
    end: PropTypes.oneOfType([
        PropTypes.bool,
        GridPropTypes.breakpointsOfType(PropTypes.bool),
    ]),
    offset: PropTypes.oneOfType([
        PropTypes.number,
        GridPropTypes.breakpointsOfType(PropTypes.number),
    ]),
    size: PropTypes.oneOfType([
        PropTypes.number,
        GridPropTypes.breakpointsOfType(PropTypes.number),
    ]).isRequired,
};

Column.defaultProps = {
    size: NumColumns,
};

export default Column;
